import { DATA_WORKSPACE_ENABLED } from "../dataWorkspaceFeature";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EmailIcon from "@mui/icons-material/Email";
import FolderIcon from "@mui/icons-material/Folder";
import GroupsIcon from "@mui/icons-material/Groups";
import FunctionsIcon from "@mui/icons-material/Functions";
import SecurityIcon from "@mui/icons-material/Security";
import Groups2Icon from "@mui/icons-material/Groups2";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import PsychologyIcon from "@mui/icons-material/Psychology";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CenterFocusWeakIcon from "@mui/icons-material/CenterFocusWeak";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";

/**
 * Doktor panel navigasyon yapılandırması.
 * @param {Function} t — i18n sidebar namespace
 * @param {{ canViewPermissionGroups?: boolean, canViewClinicalMeasurements?: boolean, isIndividualDoctor?: boolean }} access
 */
export function getDoctorNavSections(t, access = {}) {
  const { canViewPermissionGroups = false, canViewClinicalMeasurements = true, isIndividualDoctor = false } = access;

  return [
    {
      id: "main",
      label: t("main"),
      items: [
        {
          id: "dashboard",
          label: t("dashboard"),
          path: "/dashboard",
          Icon: HomeOutlinedIcon,
        },
        {
          id: "subscription",
          label: t("planAndQuotas", { defaultValue: "Plan ve Kotalar" }),
          path: "/subscription",
          Icon: WorkspacePremiumOutlinedIcon,
          visible: isIndividualDoctor,
        },
      ],
    },
    {
      id: "management",
      label: t("management"),
      items: [
        {
          id: "team",
          label: t("manageTeam"),
          path: "/team",
          Icon: PeopleOutlinedIcon,
        },
        {
          id: "patients",
          label: t("patients"),
          path: "/patients",
          Icon: ContactsOutlinedIcon,
        },
        {
          id: "files",
          label: t("files"),
          path: "/files",
          Icon: FolderIcon,
        },
        {
          id: "permission-groups",
          label: t("permissionGroups"),
          path: "/doctor-permission-groups",
          Icon: SecurityIcon,
          visible: canViewPermissionGroups,
        },
        {
          id: "collaboration-groups",
          label: t("collaborationGroups"),
          path: "/collaboration-groups",
          Icon: Groups2Icon,
        },
      ],
    },
    {
      id: "actions",
      label: t("actions"),
      items: [
        {
          id: "invite-doctor",
          label: t("inviteDoctor"),
          path: "/inviteDoctor",
          Icon: EmailIcon,
        },
        {
          id: "add-patient",
          label: t("addPatient"),
          path: "/AddPatient",
          Icon: PersonAddIcon,
        },
      ],
    },
    {
      id: "analytics",
      label: t("analytics"),
      items: [
        {
          id: "data-workspace",
          comingSoon: !DATA_WORKSPACE_ENABLED,
          label: t("dataWorkspace", { defaultValue: "Veri Çalışma Alanı" }),
          path: "/data-workspace",
          Icon: TableChartOutlinedIcon,
        },
        {
          id: "statistical-analysis",
          label: t("statisticalAnalysis"),
          path: "/statistical-analysis",
          Icon: QueryStatsOutlinedIcon,
        },
        {
          id: "feature-impact",
          label: t("featureImpact"),
          path: "/feature-impact",
          Icon: InsightsOutlinedIcon,
        },
        {
          id: "machine-learning",
          label: t("machineLearning"),
          path: "/machine-learning",
          Icon: PsychologyIcon,
        },
        {
          id: "media-vision",
          label: t("mediaVision", { defaultValue: "MediaVision" }),
          path: "/media-vision",
          Icon: CenterFocusWeakIcon,
          visible: canViewClinicalMeasurements,
        },
      ],
    },
    {
      id: "tools",
      label: t("tools"),
      items: [
        {
          id: "calendar",
          label: t("calendar"),
          path: "/calendar",
          Icon: CalendarTodayOutlinedIcon,
        },
        {
          id: "form-market",
          label: t("formMarket"),
          path: "/form-market",
          Icon: StorefrontIcon,
        },
        {
          id: "formulas",
          label: t("scoringFormulas"),
          path: "/formulas",
          Icon: FunctionsIcon,
        },
        {
          id: "excel-import",
          label: t("excelImport"),
          path: "/excel-import",
          Icon: UploadFileIcon,
        },
        {
          id: "faq",
          label: t("faq"),
          path: "/faq",
          Icon: HelpOutlineOutlinedIcon,
        },
      ],
    },
  ];
}

export function getDoctorProfileItem(t) {
  return {
    id: "profile",
    label: t("profile", { defaultValue: "Profil" }),
    path: "/profile",
    Icon: AccountCircleOutlinedIcon,
  };
}

export const DOCTOR_NAV_OPTIONS = {
  homePath: "/dashboard",
};

/** @deprecated SideBaar ile uyumluluk — yönetim bölümü ikonu */
export const DOCTOR_NAV_SECTION_ICONS = {
  management: GroupsIcon,
};
